import Cookies from "js-cookie";
import { useInfiniteQuery } from "react-query";
import { COMPANY_ID, COMPANYNAME, TOKEN_NAME } from "../config";
import { fetchUserCompanies } from "../api/idom";

export const companyPageItems = (page) =>
  Array.isArray(page?.data) ? page.data : Array.isArray(page?.data?.data) ? page.data.data : [];

export const nextCompanyPage = (lastPage, pages) => {
  const pagination = lastPage?.pagination_data || lastPage?.pagination || {};
  const hasMore = pagination.has_more_pages ?? pagination.hasMorePages;
  if (hasMore === false) return undefined;
  const next = typeof pagination.current_page_number === "number"
    ? pagination.current_page_number + 1 : pages.length;
  if (hasMore === true) return next;
  const total = Number(pagination.total_count ?? pagination.totalCount ?? lastPage?.total_count ?? lastPage?.totalCount ?? lastPage?.meta?.totalCount);
  const fetched = pages.reduce((count, page) => count + companyPageItems(page).length, 0);
  if (Number.isFinite(total)) return fetched < total ? next : undefined;
  return companyPageItems(lastPage).length < 10 ? undefined : next;
};

export const resolveCompanies = (pages = [], companyId, companyName) => {
  const selectedAndDefault = pages[0]?.selected_and_default || [];
  const selectedCompany = selectedAndDefault.find((company) => company.is_selected === true) ||
    (companyId && companyName ? { company_id: companyId, company_name: companyName } : null);
  const defaultCompany = selectedAndDefault.find((company) => company.default_company === true) || null;
  const unique = new Map();
  pages.flatMap(companyPageItems).forEach((company) => unique.set(String(company.company_id), company));
  return {
    companies: Array.from(unique.values()),
    selectedCompany,
    defaultCompany,
    isSameSelectedAndDefault: Boolean(selectedCompany && defaultCompany &&
      String(selectedCompany.company_id) === String(defaultCompany.company_id)),
  };
};

export const useUserCompanies = ({ search = "", enabled = true } = {}) => {
  const companyId = Cookies.get(COMPANY_ID);
  const query = useInfiniteQuery(
    ["user-companies", companyId || "", search],
    ({ pageParam = 0, signal }) => fetchUserCompanies({ companyId, search, page: pageParam, signal }),
    {
      enabled: enabled && Boolean(Cookies.get(TOKEN_NAME)),
      getNextPageParam: nextCompanyPage,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
  return { ...query, ...resolveCompanies(query.data?.pages, companyId, Cookies.get(COMPANYNAME)) };
};
